import { 
    ACTUALIZAR_LIST_SUBSISTEMA
  } from "./subsistemaAction";

  const subsistemaReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_SUBSISTEMA: {
            return {
                ...state,
                subsistemaList: action.payload
            }
        };

        

        default:
            return state;

    }
  }

  export default subsistemaReducer;